import { ResetPassword, ResetPasswordForm } from "./ResetPassword";
import { AppHome } from "./AppHome";
import { Login } from "./Login";
import Logout from "./Logout/Logout";
import { Dashboard } from "./Dashboard";
import { Audit } from "./Audit";
import { KudaTransactions } from "./KudaTransactions";
import { ProvidusTransactions } from "./ProvidusTransactions";
import { UpdateTransactionStatus } from "./Transaction";
import {
  PaymentMethod,
  CreatePaymentMethod,
  EditPaymentMethod,
  ViewMorePaymentMethod,
} from "./PaymentMethod";

import {
  Wallet,
  InflowReviewModal,
  CreateInflow,
  CreateInflowModal,
  ApproveBank,
  ApproveAccModal,
  AccountStatement,
  BankAccountList,
  CreateOutflow,
  CreateOutflowModal,
  OutflowReviewModal,
} from "./Wallet";
import { SignedUpBusinesses, UpdateBusiness } from "./SignedUpBusinesses";
import { Bills, ReconBills, ReconBillsModal } from "./Bills";
import { InvoiceReceipt } from "./InvoiceReceipt";
import {
  Admin,
  RevokeAdmin,
  AddAdmin,
  EditAdmin,
  PermissionList,
} from "./Admin";
import { ExchangeRate, ChangeRate } from "./ExchangeRate";
import { Settings, Security } from "./Settings";
import {
  BusinessCategory,
  AddNewCategory,
  EditCategory,
  DeleteCategory,
} from "./BusinessCategory";
import {
  FaqsCategory,
  AddFaqCategory,
  EditFaqCategory,
  DeleteFaqCategory,
  Faqs,
  AddFaq,
  EditFaq,
  DeleteFaq,
} from "./Faqs";
import { ChargeAnalysis } from "./ChargeAnalysis";
import {
  ExpenseCategory,
  AddExpenseCategory,
  EditExpenseCategory,
  DeleteExpenseCategory,
} from "./ExpenseCategory";
import { Subscription, GiveSubscription } from "./Subscription";
import { ExchangeTransactions } from "./ExchangeTransactions";
import { Charge, AddCharge, EditCharge, DeleteCharge } from "./Charge";
import { FeedbackRes, ViewMoreFeedback } from "./FeedbackRes";
import {
  FeedbackConfig,
  ConfigFeedback,
  ActivateFeedback,
} from "./FeedbackConfig";
import { Support, ViewMoreSupport, CreateSupport } from "./Support";
import { SplitPayments } from "./SplitPayments";
import {
  PublicCatalogue,
  AddCatalogueModal,
  SingleCatalogueModal,
  EditCatalogueModal,
  FashThemes,
} from "./FashCreatives";
import {
  Payout,
  ViewMorePayout,
  CreatePayout,
  ApprovePayout,
  IgnorePayout,
} from "./Payout";
import {
  Marketers,
  MarketersAnalysis,
  BusinessPartner,
  MarketerTable,
  ViewTodo,
} from "./Marketers";
import { News, CreateNews, DeleteNews, ViewMoreNews } from "./News";
import {
  Broadcast,
  CreateBroadcast,
  ViewMoreBroadcast,
  DeleteBroadcast,
  UpdateBroadcast,
  CloneBroadcast,
} from "./Broadcast";
import ForeignBankAccounts from "./ForeignBankAccounts";
import { FashBusinesses } from "./FashBusinesses";
import { StyleCategories, UpdateStyleCategory } from "./StyleCategories";
import { Prospects, AddProspect, AddBulkProspect } from "./Prospects";
import {
  MoneyExP2POrders,
  MoneyExExpressOrders,
  MoneyExAds,
  ViewMoreAds,
  MoneyExUsers,
  ViewMoreUsersInfo,
  ViewMoreInstantOrderInfo,
  VerifyInstantPayment,
  UpdateInstantPayment,
  RefundInstantPayment,
  ViewMoreP2PInfo,
  VerifyP2PPayment,
  UpdateP2PPayment,
  RefundP2PPayment,
  VerifyP2PSellerPayment,
  UpdateP2PSellerPayment,
  MoneyExLimit,
  CreateLimit,
  UpdateLimit,
  CreateAd,
  EditAd,
} from "./MoneyEx";
import {
  Competitions,
  CreateCompetition,
  EditCompetition,
  Votes,
  Participants,
  UpdateParticipants,
  CreateVotes,
} from "./Competition";

export {
  Login,
  ResetPassword,
  ResetPasswordForm,
  AppHome,
  Logout,
  Dashboard,
  Wallet,
  SignedUpBusinesses,
  Bills,
  InvoiceReceipt,
  Admin,
  RevokeAdmin,
  AddAdmin,
  EditAdmin,
  PermissionList,
  ExchangeRate,
  ChangeRate,
  InflowReviewModal,
  CreateInflow,
  CreateInflowModal,
  Settings,
  Security,
  ReconBills,
  BusinessCategory,
  AddNewCategory,
  EditCategory,
  DeleteCategory,
  ReconBillsModal,
  FaqsCategory,
  AddFaqCategory,
  EditFaqCategory,
  DeleteFaqCategory,
  Faqs,
  AddFaq,
  EditFaq,
  DeleteFaq,
  ChargeAnalysis,
  ExpenseCategory,
  AddExpenseCategory,
  EditExpenseCategory,
  DeleteExpenseCategory,
  Subscription,
  ApproveBank,
  ApproveAccModal,
  Audit,
  ExchangeTransactions,
  Charge,
  AddCharge,
  EditCharge,
  DeleteCharge,
  Support,
  ViewMoreSupport,
  FeedbackRes,
  ViewMoreFeedback,
  FeedbackConfig,
  ConfigFeedback,
  ActivateFeedback,
  CreateSupport,
  AccountStatement,
  SplitPayments,
  KudaTransactions,
  ProvidusTransactions,
  BankAccountList,
  PublicCatalogue,
  AddCatalogueModal,
  SingleCatalogueModal,
  EditCatalogueModal,
  UpdateTransactionStatus,
  Payout,
  ViewMorePayout,
  CreatePayout,
  ApprovePayout,
  IgnorePayout,
  CreateOutflow,
  CreateOutflowModal,
  OutflowReviewModal,
  News,
  CreateNews,
  Marketers,
  MarketersAnalysis,
  DeleteNews,
  ViewMoreNews,
  Broadcast,
  CreateBroadcast,
  ViewMoreBroadcast,
  DeleteBroadcast,
  BusinessPartner,
  MarketerTable,
  ForeignBankAccounts,
  FashBusinesses,
  StyleCategories,
  UpdateBroadcast,
  CloneBroadcast,
  GiveSubscription,
  UpdateStyleCategory,
  ViewTodo,
  MoneyExAds,
  MoneyExUsers,
  ViewMoreUsersInfo,
  ViewMoreAds,
  ViewMoreInstantOrderInfo,
  VerifyInstantPayment,
  UpdateInstantPayment,
  RefundInstantPayment,
  ViewMoreP2PInfo,
  VerifyP2PPayment,
  UpdateP2PPayment,
  RefundP2PPayment,
  MoneyExP2POrders,
  MoneyExExpressOrders,
  VerifyP2PSellerPayment,
  UpdateP2PSellerPayment,
  MoneyExLimit,
  CreateLimit,
  UpdateLimit,
  PaymentMethod,
  CreatePaymentMethod,
  EditPaymentMethod,
  Prospects,
  AddProspect,
  UpdateBusiness,
  AddBulkProspect,
  FashThemes,
  ViewMorePaymentMethod,
  CreateAd,
  EditAd,
  Competitions,
  CreateCompetition,
  EditCompetition,
  Votes,
  Participants,
  UpdateParticipants,
  CreateVotes,
};
